var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ScoreBigBallRoot } from './styled';
import BigBallSvg from "../BigBallSvg";
import { formatScore } from "../../utils/utils";
var ScoreBigBall = function (_a) {
    var score = _a.score, status = _a.status, _b = _a.width, width = _b === void 0 ? 80 : _b, _c = _a.height, height = _c === void 0 ? 80 : _c, _d = _a.fontSize, fontSize = _d === void 0 ? 20 : _d;
    return (_jsxs(_Fragment, { children: [_jsxs(ScoreBigBallRoot, __assign({ width: width, height: height, sx: { backgroundColor: status === 1 ? '#fbfbfb' : 'rgba(59, 203, 120, 0.1)' } }, { children: [status !== 1 && _jsx(BigBallSvg, {}), status === 1 && (_jsx("div", __assign({ style: { color: 'rgba(0,0,0,0.26)', fontSize: '12px' } }, { children: _jsx("span", { children: "\u5019\u9009\u4EBA\u672A\u4F5C\u7B54" }) }))), status === 2 && (_jsx("div", __assign({ style: { color: '#40be47' } }, { children: _jsx("span", { children: "\u8BA1\u7B97\u4E2D..." }) }))), status === 3 && (_jsxs("div", __assign({ style: { color: '#40be47' } }, { children: [_jsx("span", __assign({ style: { fontFamily: 'MiSans TC', fontSize: fontSize, fontWeight: 'bold' } }, { children: formatScore(score) > 100 ? 100 : formatScore(score) })), _jsx("span", __assign({ style: { marginLeft: '2px', fontSize: '12px' } }, { children: "\u5206" }))] })))] })), status === 2 && (_jsx("div", { style: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                } }))] }));
};
export default ScoreBigBall;
